import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionTag = ({ children }) => (
  <p className="font-display text-[11px] font-medium uppercase tracking-[0.35em] text-cyan-300/90">
    {children}
  </p>
);

export const StatusPill = ({ children, tone = "cyan", ...rest }) => {
  const tones = {
    cyan: "border-cyan-300/30 bg-cyan-300/10 text-cyan-200",
    amber: "border-amber-300/30 bg-amber-300/10 text-amber-200",
    white: "border-white/15 bg-white/5 text-white/70",
  };
  return (
    <span {...rest} className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] ${tones[tone]}`}>
      {children}
    </span>
  );
};
